var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"label":"Template Name","items":_vm.templateItems},on:{"change":_vm.onSelectTemplate},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }